import * as moment from 'moment';
import { IAccountPreferences } from '../features/account/model';
import timezones from './static/Timezones';

import 'moment-timezone';

// Expects UTC date string, otherwise date is converted to UTC
export const getDate = (dateString: string, dateFormat: string = 'DD-MM-YYYY HH:mm', timezone?: string) => {
	const jsTimezoneObj = timezone && getTimezoneObjectFromKey(timezone);
	const jsTimezone = jsTimezoneObj && jsTimezoneObj.js;

	if (timezone) {
		return (moment as any).tz(moment.utc(dateString).format(), jsTimezone).format(dateFormat);
	} else {
		return moment.utc(dateString).format(dateFormat);
	}
};

export const getLocalDate = (dateString: string, dateFormat: string = 'DD-MM-YYYY HH:mm') => {
	return moment(dateString).format(dateFormat);
};

export const getLocalTimezone = () => {
	const zone = (moment as any).tz.guess();
	return (moment as any).tz(zone).zoneAbbr();
};

export const getTimezoneLabelFromKey = (key: string) => {
	const timezoneObj = timezones.find((timezone) => timezone.key === key);
	return (timezoneObj && timezoneObj.text) || null;
};
export const getTimezoneObjectFromKey = (key: string) => {
	const timezoneObj = timezones.find((timezone) => timezone.key === key);
	return timezoneObj;
};

export const getDateAccordingToPreferences = (
	dateString?: string,
	accountPreferences?: IAccountPreferences,
	ignoreTimezone: boolean = false
) => {
	if (dateString) {
		if (accountPreferences && accountPreferences.TimeFormat && accountPreferences.DateFormat) {
			const TimeFormat = accountPreferences.TimeFormat.replace(/tt/g, 'A');
			const DateFormat = accountPreferences.DateFormat.toUpperCase();

			const timezone = (!ignoreTimezone && accountPreferences.Timezone) || undefined;

			return getDate(dateString, `${DateFormat} ${TimeFormat}`, timezone);
		}

		return getDate(dateString, 'DD-MM-YYYY hh:mm A');
	}
};
